import { route } from '../helpers';

import urls from '../../urls';
import SeasonSearchActions from '../../actions/SeasonSearchActions';
import { SeasonStages } from '../../constants/AppConstants';

export default route(SeasonStages.INIT, {
    async onEnter ({ location, params }, replace, callback) {
        try {
            await SeasonSearchActions.loadFromParams(params, location.query);
        } catch (error) {
            console.error(error);
        }
        replace(urls.location(SeasonStages.SEARCH));
        callback();
    }
});
